import { Faq } from './Faq';
import { Section } from './Section';
import { shopFaq } from '../../data/faq';
import { shopFaqTitle } from '../../data/pageActions';
type Props = {
  /** Hoeveel vragen: leeg = alles (webshop), een getal = de korte versie (Protocollen). Altijd dezelfde woorden. */
  limit?: number;
};

/** De vragen over bestellen, ruilen en bijvullen: één bron voor Webshop en Protocollen. Zonder vragen geen lege band. */
export function ShopFaq({
  limit
}: Props) {
  const items = limit === undefined ? shopFaq : shopFaq.slice(0, limit);
  if (items.length === 0) return null;
  return <Section tone="sand" label={shopFaqTitle} data-id="element-9031" data-mp="3oqfjvqymfhzk">
      <Faq items={items} title={shopFaqTitle} data-id="element-9032" data-mp="3or7ilanilvu2" />
    </Section>;
}